import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
function Founder() { 
  useEffect(() => {
    document.title = 'Founder -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Founder</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Founder</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                 <div className="clearfix founderdiv">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/founder1.jpg" className="col-md-3 founderimg float-md-start mb-3 ms-md-3 img-fluid" alt="Mercy Memorial School, Kanpur"/></LazyLoad>
                     <h5> Mrs. Sophie Shukla, July 31, 1928 - October 28, 1985 </h5>
                     <p>Mrs. Sophie Shukla belonged to a family of dedicated and devoted Indian Christian Missionaries, her father being a Priest and her elder sister an Educationist. The stamp of piety and pedagogy had its lasting impact on her personality and she proved worthy of her family's heritage by entering into the teaching procession, and in her later years turned into a Missionary. She imbibed in her the amalgam of both spirit and wisdom which shines forth through the annals and corridors of Mercy Memorial Academy, which aims at producing not through the annals and corridors of Mercy Memorial Academy, which aims at producing not only great men of letters but also patriots and people devoted to the service of humanity. </p>
                </div>
                <div className="clearfix">
                <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/founder2.jpg" className="col-md-3 founderimg float-md-start mb-3 ms-md-3 img-fluid" alt="Mercy Memorial School, Kanpur"/></LazyLoad>
                <h5>  Ms. Mercy Roberts, September 25, 1916 - June 19, 1972 </h5>
                <p>Ms. Mercy Roberts, a proud product of Roberts family of Shikohabad, responded to the call of the spirit and shunned the worldly pleasures to become a humble servant of Lord Jesus Christ for whose glory she remained a spinster throughout. With a resolute mind and indefatigable will, she worked for the Methodist Church and its educational institutions as Principal and Manager at various placed in Uttar Pradesh. This Institution shall always endeavour to live upto her ideals.</p>
                <p>Each heart beat of hers was for the upliftment of others. She worked with missionary zeal to enlighten each soul with the light of knowledge. Her sudden demise in 1972 left every one giving stricken and her sisters sincere tribute to her was the establishment of Mercy memorial School in 1983 to be able to fulfill and achieve the goals left behind by her.</p>
                <p>This Institution shall endeavor to live upto her ideals.</p>
                </div>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Founder;
